import React, { useEffect, useRef, useState, useContext } from 'react';
import { useChat, useLocalParticipant } from '@livekit/components-react';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { Context } from '../../../..';

const ChatRoom = ({ isOpen = true, onClose }) => {
    const { chatMessages, send } = useChat();
    const chatRef = useRef(null);
    const { user } = useContext(Context);
    const { localParticipant } = useLocalParticipant();

    const [input, setInput] = useState('');
    const [emojiPanelVisible, setEmojiPanelVisible] = useState(false);

    useEffect(() => {
        if (localParticipant?.permissions?.canUpdateMetadata) {
            const fullName = `${user.user.first_name} ${user.user.last_name}`;
            localParticipant.setName(fullName);
        }
    }, [localParticipant, user]);

    useEffect(() => {
        if (chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
    }, [chatMessages]);

    const handleEmojiClick = () => setEmojiPanelVisible(!emojiPanelVisible);
    const hideEmojiPicker = () => setEmojiPanelVisible(false);
    const handleEmojiSelect = (emoji) => {
        setInput((prev) => prev + ' ' + emoji.native);
    };

    const handleSend = async () => {
        if (!input.trim()) return;
        await send(
            JSON.stringify({
                text: input.trim(),
                sender: `${user.user.first_name} ${user.user.last_name}`.trim(),
            })
        );
        setInput('');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') handleSend();
    };

    return (
        <div className={`w-full bg-[#E5D8FF] rounded-2xl p-6 ${isOpen ? '' : 'hidden'}`}>
            {/* Чат-сообщения */}
            <div
                ref={chatRef}
                className="max-h-[250px] min-h-[250px] overflow-auto mb-4 flex flex-col gap-4"
            >
                {chatMessages.map((msg, index) => {
                    let parsed;
                    try {
                        parsed = JSON.parse(msg.message);
                    } catch (e) {
                        parsed = null;
                    }

                    const name = parsed?.sender || msg.sender?.identity || 'Аноним';
                    const text = parsed?.text || msg.message;

                    return (
                        <div key={index} className="flex gap-3 text-sm">
                            <div className="rounded-full w-6 h-6 bg-violet-600 shrink-0 mt-1" />
                            <div>
                                <p className="font-semibold text-[#6C38CC]">{name}</p>
                                <p className="text-[#363645] whitespace-pre-wrap">{text}</p>
                            </div>
                        </div>
                    );
                })}

            </div>

            {/* Ввод сообщения */}
            <div className="flex items-center bg-white px-4 py-2 rounded-full gap-3">
                <div className="relative">
                    <div
                        className={`absolute bottom-[100%] z-50 ${emojiPanelVisible ? '' : 'hidden'}`}
                        onMouseLeave={hideEmojiPicker}
                    >
                        <Picker
                            data={data}
                            onEmojiSelect={handleEmojiSelect}
                            emojiSize={18}
                            emojiButtonSize={28}
                            theme="light"
                            emojiStyle="apple"
                            previewPosition="none"
                        />
                    </div>

                    <div className="cursor-pointer" onClick={handleEmojiClick}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 2C17.52 2 22 6.48 22 12s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 1.5C7.31 3.5 3.5 7.31 3.5 12S7.31 20.5 12 20.5 20.5 16.69 20.5 12 16.69 3.5 12 3.5zM8.46 14.78c.42.53.96.96 1.6 1.25.64.29 1.34.45 2.04.45.7 0 1.4-.16 2.04-.45.64-.29 1.18-.72 1.6-1.25.18-.23.52-.27.75-.09.23.18.27.52.09.75a6.46 6.46 0 01-2.44 1.91 6.49 6.49 0 01-5.08 0 6.46 6.46 0 01-2.44-1.91.526.526 0 11.84-.66zm.54-5.03c.69 0 1.25.56 1.25 1.25S9.69 12.25 9 12.25 7.75 11.69 7.75 11s.56-1.25 1.25-1.25zm6 0c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25S13.75 11.69 13.75 11s.56-1.25 1.25-1.25z" fill="#9B9BAA" />
                        </svg>
                    </div>
                </div>

                <input
                    className="w-full text-sm placeholder:text-[#9B9BAA] text-[#363645] outline-none"
                    placeholder="Введите сообщение..."
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={handleKeyPress}
                />

                <button onClick={handleSend} className="shrink-0">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M2.65 19.39c-1.5.73-3.15-.7-2.46-2.14L3.66 10 0.19 2.75c-.69-1.44 1-2.87 2.49-2.14l16.12 7.92a2.12 2.12 0 010 3.84L2.65 19.39z" fill="#6446C3" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default ChatRoom;
